// Gender + theme → body-sequence mapping. Owned by docs/asset-naming.md#gender-mapping.
//
// The body sprite now varies by BOTH gender and theme (client request,
// 2026-06): `body_{m|f}{theme}_{frame}.png`, e.g. body_m0_2.png = male, theme 0,
// frame 2. The head is unaffected — gender+theme only pick which body draws
// beneath the player's uploaded face.

import type { Theme } from "../state/types";

export function bodyFrameName(isMale: boolean, theme: Theme, frame: 0 | 1 | 2 | 3): string {
  const g = isMale ? "m" : "f";
  return `body_${g}${theme}_${frame}.png`;
}

export function bodyFrameNames(isMale: boolean, theme: Theme): string[] {
  return [0, 1, 2, 3].map((f) => bodyFrameName(isMale, theme, f as 0 | 1 | 2 | 3));
}

/** The static foreground hand (holds the cup), per gender×theme — one image
 *  reused across all 4 body frames: `body_{m|f}{theme}_hand.png`. It's derived
 *  from the body art (same canvas/registration, only the right hand kept), so it
 *  shares the body's offset/size in characterVisual.hand. Drawn in front of the
 *  cup, behind the head. Optional art: absent files degrade to no hand. */
export function handName(isMale: boolean, theme: Theme): string {
  const g = isMale ? "m" : "f";
  return `body_${g}${theme}_hand.png`;
}
